export default "__VITE_ASSET__B$JRw09U__"